"use strict";require("core-js/modules/es.function.name");exports.__esModule = true;exports.debounce = debounce;exports.throttle = throttle;exports.sortCb_num = sortCb_num;exports.sortCb_str = sortCb_str;exports.sortCb_collByName = sortCb_collByName;exports.castFunc = castFunc;

var _is = require("./is");




/**
                            * @namespace __Function
                            */

/**
                                * Вернёт версию функции, исполнение которой начнётся не ранее,
                                * чем истечёт промежуток wait, после её последнего вызова
                                *
                                *
                                * @param {function} func
                                * @param {number} ms
                                * @example
                                * const lazyOnresizeCallback = _.debounce(calculateLayout, 300);
                                * window.onresize = lazyOnresizeCallback
                                * @returns {function}
                                * @memberof __Function
                                */
function debounce(func, ms) {
  var timer = null;

  var clearTimer = function clearTimer() {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return function () {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    var onComplete = function onComplete() {
      func.apply(void 0, args);
      clearTimer();
    };

    clearTimer();

    timer = setTimeout(onComplete, ms);
  };
}



/**
   * Вернёт версию функции, которая будет вызываться не чаще чем ms
   *
   *
   * @param {function} func
   * @param {number} ms
   * @example
   * const lazyOnresizeCallback = _.throttle(calculateLayout, 300);
   * window.onresize = lazyOnresizeCallback
   * @returns {function}
   * @memberof __Function
   */
function throttle(func, ms, runLast) {if (runLast === void 0) {runLast = true;}

  var isWaiting = false;
  var savedArgs;

  function resultFunc() {for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}

    if (isWaiting) {
      savedArgs = args;
      return;
    }

    func.apply(void 0, args);

    isWaiting = true;

    setTimeout(function () {
      isWaiting = false;
      if (savedArgs) {
        if (runLast) {
          resultFunc.apply(void 0, savedArgs);
        }
        savedArgs = null;
      }
    }, ms);
  }

  return resultFunc;
}






/**
   * Функция сортировки чисел от меньшего к большему
   *
   *
   * @param {number} a
   * @param {number} b
   * @example
   * [ 3, 7, 1 ].sort( sortCb_num ) // [ 1, 3, 7 ]
   * @returns {number}
   * @memberof __Function
   */
function sortCb_num(a, b) {
  switch (true) {
    case a < b:
      return -1;
    case a > b:
      return 1;
    default:
      return 0;}

}

/**
   * Функция для сортировки строк по алфавиту
   *
   *
   * @param {string} a
   * @param {string} b
   * @example
   * [ 'Z', '1', 'A' ].sort( sortCb_str ) // [ '1', 'A', 'Z' ]
   * @returns {number}
   * @memberof __Function
   */
function sortCb_str(a, b) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}


/**
   * Функция для сортировки массива объектов по свойству name по алфавиту
   *
   *
   * @param {{ name: string }} a
   * @param {{ name: string }} b
   * @example
   * [ { name: 'Z' }, { name: 'A' } ].sort( sortCb_collByName )
   * // [ { name: 'A' }, { name: 'Z' } ]
   * @returns {number}
   * @memberof __Function
   */
function sortCb_collByName(a, b) {
  return sortCb_str(a.name, b.name);
}


/**
   * Возвращает аргумент, если тот является функцией, иначе пустую функцию
   *
   *
   * @param {*} maybeFunc
   * @example
   * const exampleFunc = () => [ 1, 2 ]
   * castFunc( func ) // exampleFunc
   * castFunc( 3 ) // function () {}
   * @returns {function}
   * @memberof __Function
   */
function castFunc(maybeFunc) {
  return (0, _is.isF)(maybeFunc) ? maybeFunc : function () {};
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/func.js
// module id = 126
// module chunks = 0